import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgToseeTaavon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#tosee_taavon_svg__a)'>
      <path
        fill='#0A8992'
        d='M11.838-.002h.258c.273.022.562.064.789.231q1.328 1.003 2.66 2-.711 2.493-1.426 4.984a4.3 4.3 0 0 0-1.645-.429c-.793-.053-1.607.074-2.325.43q-.976-2.385-1.95-4.771L10.925.21c.08-.065.182-.087.28-.113q.312-.078.633-.1m-8.895 3.97c1.088-.306 2.179-.604 3.267-.908L9.14 7.306c-.563.272-1.05.688-1.455 1.168-.482.577-.855 1.263-1.02 2.007L1.797 9.067q-.003-1.788-.01-3.575c.007-.155.094-.29.155-.428.225-.446.541-.885 1-1.096zm12.171 3.665q1.351-2.186 2.712-4.367l3.357 1.01c.093.026.164.097.235.159.333.295.626.653.786 1.077.043.122.083.25.08.381l-.08 3.406a1355 1355 0 0 1-4.818 1.659c-.107-.703-.405-1.365-.803-1.941-.388-.559-.88-1.05-1.47-1.382zm2.508 4.044 5.03-.554 1.319 3.304c.044.104.027.22.025.33-.026.496-.137 1.007-.43 1.414-.088.13-.225.211-.345.308-.817.635-1.637 1.266-2.453 1.904a1157 1157 0 0 1-4.274-2.815c.43-.48.737-1.068.935-1.685.226-.707.314-1.469.194-2.206zM.138 14.131l1.212-2.955 5.077.248c-.192.892-.077 1.834.23 2.685.164.457.401.882.702 1.26l-4.083 3.056Q1.898 17.333.517 16.242c-.091-.069-.136-.18-.189-.278-.22-.444-.371-.943-.317-1.444.013-.138.075-.263.126-.39m7.826 2.018c.385.545.91.975 1.482 1.3.62.348 1.314.576 2.025.6-.152 1.717-.311 3.433-.463 5.15l-3.43.666c-.113.023-.226-.016-.336-.042-.394-.107-.785-.274-1.098-.55-.11-.1-.22-.208-.284-.347q-.719-1.53-1.442-3.056l3.547-3.722m6.297 1.602c.654-.292 1.259-.72 1.714-1.287l3.719 3.504c-.313.647-.633 1.289-.948 1.934-.226.442-.427.9-.666 1.335a2.9 2.9 0 0 1-1.122.685c-.2.056-.413.104-.62.057q-1.616-.343-3.233-.682-.372-2.571-.74-5.138c.652.016 1.299-.143 1.894-.407z'
      />
      <path
        fill='#706F6E'
        d='M11.629 8.376a3.77 3.77 0 0 1 2.664.684 3.92 3.92 0 0 1 1.533 2.33 4 4 0 0 1-.385 2.78 3.86 3.86 0 0 1-2.107 1.803 3.76 3.76 0 0 1-2.745-.1 3.87 3.87 0 0 1-1.975-1.953 4 4 0 0 1-.19-2.801 3.9 3.9 0 0 1 1.692-2.212 3.8 3.8 0 0 1 1.513-.53'
      />
    </g>
    <defs>
      <clipPath id='tosee_taavon_svg__a'>
        <path fill='#fff' d='M0-.002h24.001v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgToseeTaavon)
export default ForwardRef
